<template>
  <table class="striped_table w-100">
    <tr>
      <td><label>{{ $t('generic.id') }}:</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}:</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}:</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.last_login_at') }}:</label></td>
      <td><span v-if="details.last_login_at">{{ details.last_login_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.username') }}:</label></td>
      <td>{{ details.username }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.role') }}:</label></td>
      <td>{{ details.role }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.status') }}:</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.organisation') }}:</label></td>
      <td>{{ details.organisation }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.first_name') }}:</label></td>
      <td>{{ details.first_name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.last_name') }}:</label></td>
      <td>{{ details.last_name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.contact_number') }}:</label></td>
      <td>{{ details.contact_number }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.email') }}:</label></td>
      <td>{{ details.email }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.language') }}:</label></td>
      <td>{{ details.language }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.cidrs') }}:</label></td>
      <td>{{ details.cidrs }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.assigned_distributor_client') }}:</label></td>
      <td>
        <router-link v-if="details.distributor_client"
                     :to="distributorPath()">
          {{ details.distributor_client.name }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.token_hash') }}:</label></td>
      <td>
        <div class="row m-0 p-0">
          <div class="col m-0 p-0 align-self-center">
            {{ details.token_hash != null ? details.token_hash : '' }}
          </div>
          <div class="col m-0 p-0" v-if="$auth.can({system_account: 'update'}, 'permissions')">
            <modify-system-account-token-btn class="float-right"/>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.metadata') }}:</label></td>
      <td>
        <meta-data-details :data="details.metadata"/>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('system_account.details.assigned_operators') }}:</label></td>
      <td class="pl-2">
        <assigned-operators-table :data="details.assigned_operators?details.assigned_operators:[]"/>
      </td>
    </tr>
  </table>
</template>
<script>
import AssignedOperatorsTable from "src/components/Operator/AssignedOperatorsTable";
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";
import ModifySystemAccountTokenBtn from './ModifySystemAccountTokenBtn';

export default {
  name: 'email-details',
  components: {
    MetaDataDetails,
    AssignedOperatorsTable,
    ModifySystemAccountTokenBtn
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    distributorPath() {
      let props = this.$router.resolve({
        name: 'distributor',
        params: {id: this.details.distributor_client.distributor_id},
      });
      return props.href
    }
  }
};
</script>
<style></style>
